import axios from "axios";
import qs from "qs";
import router from "../router/index";
import { Notification } from "element-ui";
// let CancelToken = axios.CancelToken;
axios.defaults.timeout = 10 * 60 *1000;
// import errorhandler from "./errorhandler";
// import { message } from "antd";
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.defaults.baseURL = `${process.env.VUE_APP_BASE_URL}/${process.env.VUE_APP_CONTENT_PATH}`;
axios.interceptors.request.use(
  (config) => {
    // 得到参数中的requestname字段，用于决定下次发起请求，取消相应的  相同字段的请求
    // let requestName = config.url;
    // // 判断，如果这里拿到上一次的requestName，就取消上一次的请求
    // if (requestName) {
    //   if (axios[requestName] && axios[requestName].cancel) {
    //     axios[requestName].cancel();
    //   }
    //   config.cancelToken = new CancelToken(c => {
    //     axios[requestName] = {};
    //     axios[requestName].cancel = c;
    //   });
    // }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axios.interceptors.response.use(
  (res) => {
    if (
      res.data.code !== "0000" &&
      res.data.code !== undefined &&
      res.config.method !== "options"
    ) {
      res.data.code == "3000"
        ? router.push("/login")
        : Notification({
            title: "tip",
            message: res.data.msg,
            type: "error",
          });
    }
    // console.log(res)
    if (res.headers.location) {
      window.location.href = res.headers.location;
    }
    return res;
  },
  (err) => {
    // Notification({
    //   title: 'tip',
    //   message: 'serve error',
    //   type: 'error'
    // });
    // router.push('login')
    if (err.response.status == 401 && err.response.headers.location) {
      let loginUrl = err.response.headers.location;
      window.location.href = loginUrl;
    }
    return Promise.reject(err);
  }
);

export default async (url, params = {}, method = "POST", isUpload = false) => {
  const getCookie = (name) => {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2)
      return parts
        .pop()
        .split(";")
        .shift();
  };

  method = method.toUpperCase();
  if (method === "GET") {
    const res = await axios.get(
      url,
      { params },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return qs.parse(res.data);
  } else if (method === "DELETE") {
    const res = await axios.delete(url, {
      params,
    });
    return res.data;
  } else if (method === "POST") {
    const normal = {
      transformRequest: [
        function(data) {
          return qs.stringify(data);
        },
      ],
      headers: { "X-CSRFToken": getCookie("csrftoken") },
    };
    const upload = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const res = await axios.post(url, params, isUpload ? upload : normal);
    // console.log(res);
    return res.data;
  } else if (method === "POST_JSON") {
    const res = await axios.post(url, params, {
      headers: { "Content-Type": "application/json" },
      // headers: { "Content-Type":"application/x-www-form-urlencoded; charset=UTF-8"}
    });
    return res.data;
  } else if (method === "PUT") {
    const res = await axios.put(url, params, {
      headers: { "Content-Type": "application/json" },
    });
    return res.data;
  } else if (method === "GET_IMAGE") {
    const res = await axios.get(
      url,
      { params, responseType: "blob" },
      {
        headers: { "Content-Type": "image/jpg" },
      }
    );
    return res.data;
  } else if (method === "POST_T") {
    const res = await axios.post(url, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return res.data;
  } else if (method === "LOGIN") {
    const res = await axios.get(
      url,
      { params },
      {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }
    );
    return res.data;
  }
};
